export default "__VITE_ASSET__kuY1CFCH__"